import styled from "styled-components";

export const Wrapper = styled("div")(({ theme }) => ({
  ...theme.mixins.flexAlignCenter,
  position: "relative",
}));

export const Label = styled("label")(({ theme }) => ({
  ...theme.mixins.flexAlignCenter,
  fontSize: 12,
  lineHeight: "16px",
}));

export const CheckboxInput = styled("input")(({ theme }) => ({
  position: "absolute",
  left: 0,
  top: 0,
  zIndex: 2,
  width: "100%",
  height: "100%",
  opacity: 0,
  margin: 0,
  cursor: "pointer",
}));

export const CheckboxBlock = styled("div")(({ theme, $hasLabel, $checked }) => ({
  ...theme.mixins.flexAlignCenter,
  justifyContent: "center",
  width: 18,
  height: 18,
  border: `1px solid ${$checked ? theme.palette.fly.brand : theme.palette.fly.checkboxBorder}`,
  marginRight: $hasLabel ? 8 : 0,
  borderRadius: 3,
  backgroundColor: $checked ? theme.palette.fly.brand : theme.palette.fly.checkboxBg,
  color: theme.palette.white,
  fontSize: 14,
  transition: "all .2s ease",
}));
